import React, { PureComponent } from "react";

const LimiteTarjeta = (props) => {
    const { Cuenta, guardarCampoCuenta, onKeyPressSoloNumeros, onChangeLimiteTarjeta } = props;
    if (Cuenta.ModalidadDistribucionLimiteId > 1) {
        return (
            <div className="row">
                <div className="col-xs-12">
                    <label className="label-primary">Límite por defecto para cada tarjeta (opcional)</label>
                </div>
                <div className="col-xs-2">
                    <input type="text"
                        maxLength="3"
                        className="form-control default-input"
                        value={Cuenta.LimiteDefaultTarjetas}
                        onKeyPress={onKeyPressSoloNumeros}
                        onChange={onChangeLimiteTarjeta} />
                </div>
                <div className="col-xs-10">
                    <p>% del límite de la cuenta</p>
                </div>
            </div>
        );
    } else {
        return null;
    }
}

class RadioButtonLimits extends PureComponent {
    constructor(props) {
        super(props);
        this.onKeyPressSoloNumeros = this.onKeyPressSoloNumeros.bind(this);
        this.onChangeLimiteTarjeta = this.onChangeLimiteTarjeta.bind(this);
    }

    /**
     * 
     * @param {any} event
     */
    onKeyPressSoloNumeros(event) {
        /*Valido Numeros*/
        if ((/\d/g).test(event.key) == false) {
            event.preventDefault();
        }
    }

    /**
     * 
     * @param {any} event
     */
    onChangeLimiteTarjeta(event) {
        /*Obtengo el valor*/
        let value = event.target.value;
        /*Saco las letras en caso de que hayan pegado un texto y lo transformo en numero*/
        value = parseInt(value.replace(/\D/g, ""));
        /*Si no es un numero, entonces actualizo el estado con un vacio*/
        if (isNaN(value)) {
            this.props.guardarCampoCuenta("", "LimiteDefaultTarjetas");
        } else {
            /*De lo contrario pregunto si el numero ingresado es mayor a 100, si lo es, lo fuerzo a 100 de lo contrario lo guardo*/
            value = value > 100 ? 100 : value;
            this.props.guardarCampoCuenta(value, "LimiteDefaultTarjetas");
        }
    }

    render() {

        const { Validaciones, ValidarPantalla, GET_MODALIDAD_DISTRIBUCION_LIMITE, Cuenta, guardarCampoCuenta } = this.props;

        const radioModalidades = GET_MODALIDAD_DISTRIBUCION_LIMITE.map((modalidad, index) => {
            let estaSeleccionado = (modalidad.Id == Cuenta.ModalidadDistribucionLimiteId);
            let deshabilitada = (modalidad.Id == 1 && Cuenta.checkDescentralizada ? true : false);
            return (
            <div className="col-md-4" key={"modalidad-limite-" + index} >
                <div className="container-radio radio-margin">
                    <input type="radio"
                        name="modalidad-limite"
                        value={modalidad.Id}
                        id={"modalidad-limite-radio-" + index}
                        checked={estaSeleccionado}
                        disabled={deshabilitada}
                        onChange={(event) => guardarCampoCuenta(event.target.value, "ModalidadDistribucionLimiteId")} />
                    <label className="lbl-radio label-secondary" htmlFor={"modalidad-limite-radio-" + index}>{modalidad.Descripcion}</label>
                    <div>
                        <p>{modalidad.Explicacion}</p>
                    </div>
                </div>
            </div>
            );
        });


        let mensajeError = null
        if (ValidarPantalla == true) {
            if (Validaciones.ModalidadDistribucionLimiteSeleccionada == false) {
                mensajeError = <label className="error">Por favor seleccione el modelo de asignación de limites</label>
            }
        }

        return (
        <div className="bottom-separator-xs">
            <div className="row">
                <div className="col-xs-12">
                    <label className="label-primary">Modelo de asignación de límites a tarjetas</label>
                </div>
            </div>

            <div className="row">
                <div className="col-xs-12">
                    {radioModalidades}
                </div>
                <div className="col-xs-12">
                    {mensajeError}
                </div>
            </div>

            <div className="row">
                <div className="col-xs-12">
                    <LimiteTarjeta Cuenta={Cuenta} onChangeLimiteTarjeta={this.onChangeLimiteTarjeta} onKeyPressSoloNumeros={this.onKeyPressSoloNumeros} />
                </div>
            </div>
        </div>
        );
    }
}

export default RadioButtonLimits;